






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {StatusCarga} from '@/model/resource/StatusCarga'
import {InputStatusCargaSchema} from '@/schema/resource/StatusCarga/InputStatusCargaSchema'

@Component
export default class PersistStatusCargaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputStatusCargaSchema()
  statusCarga = new StatusCarga()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.statusCarga.getStatusCarga(id)
    }

    $.await.done('getStatusCarga')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.statusCarga.persistStatusCarga()
    await Helper.successAndPush('system.success.persist', '/status-carga/list')
  }
}
